import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const ConfirmSignOutModal = ({ hideModal, signOut }: any) => {
  return (
    <div className='modal'>
      <div
        className='modal-background'
        onClick={() => hideModal()}
      ></div>
      <div className='modal-content'>
        <div className='box'>
          <div className='flex border-b'>
            <div className='flex-1 font-bold p-4'>خروج</div>
            <div>
              <button
                onClick={() => hideModal()}
                className='p-4'
                aria-label='close'
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          </div>

          <div className='p-2'>
            آیا می‌خواهید از حساب کاربری‌ خود خارج شوید؟
          </div>

          <div className='p-2 border-t flex'>
            <button
              onClick={() => hideModal()}
              className='rounded p-2 flex-1 bg-rose-900 text-white'
            >
              خیر
            </button>

            <button
              className='flex-1 p-2 text-rose-900'
              onClick={() => signOut()}
            >
              بله
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmSignOutModal;
